import { defineComponent as _defineComponent } from 'vue'
import { unref as _unref, toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, createTextVNode as _createTextVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, renderList as _renderList, Fragment as _Fragment, createVNode as _createVNode, normalizeClass as _normalizeClass, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-491d2a6a"),n=n(),_popScopeId(),n)
const _hoisted_1 = {
  class: "modal fade",
  id: "interest",
  tabindex: "-1",
  "aria-labelledby": "interest",
  "aria-hidden": "true"
}
const _hoisted_2 = { class: "modal-content" }
const _hoisted_3 = { class: "modal-header" }
const _hoisted_4 = { class: "fw-bold text-center w-100 fs-5 text-center" }
const _hoisted_5 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("i", { class: "far fa-hand-paper fs-5" }, null, -1))
const _hoisted_6 = { class: "interest" }
const _hoisted_7 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("button", {
  type: "button",
  class: "btn-close",
  "data-bs-dismiss": "modal",
  "aria-label": "Close"
}, null, -1))
const _hoisted_8 = { class: "modal-body" }
const _hoisted_9 = {
  key: 0,
  class: "d-flex justify-content-center mb-5 py-3"
}
const _hoisted_10 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "spinner-border" }, null, -1))
const _hoisted_11 = [
  _hoisted_10
]
const _hoisted_12 = {
  key: 1,
  class: "px-lg-2 h-500 scroll_y_layout"
}
const _hoisted_13 = { class: "d-flex align-items-center fs-7 fw-bold col-6 col-lg-5 text-break" }
const _hoisted_14 = { class: "d-flex flex-column justify-content-end col-6 col-lg-7 fs-7" }
const _hoisted_15 = { class: "d-flex justify-content-end justify-content-xl-between align-items-center" }
const _hoisted_16 = { class: "me-2 d-none d-xl-inline" }
const _hoisted_17 = {
  key: 0,
  "data-bs-dismiss": "modal"
}
const _hoisted_18 = { class: "modal-footer justify-content-center" }

import UserAliasIcon from '@/components/user-alias-icon/index.vue'
import Button from '@/components/button/index.vue'
import { translate } from '@/languages/i18n'
import { computed, ComputedRef } from 'vue'
import { useStore } from 'vuex'
import { POST_STORE } from '@/store/constants'
import { useRoute, useRouter } from 'vue-router'
import dayjs from 'dayjs'
import { usePath } from '@/use/usePath'

type InterestType = {
  chat_link: string
  created_at: string
  family_name: string
  given_name: string
  management_no: string
  user_type: string
}


export default /*#__PURE__*/_defineComponent({
  setup(__props) {

const store = useStore()
const route = useRoute()
const { path, id } = usePath()
const router = useRouter()

const data = computed<ComputedRef<Array<InterestType>>>(() => store.getters[POST_STORE.GETTERS.INTEREST]?.interest)
const loading = computed(() => store.getters[POST_STORE.GETTERS.INTEREST]?.loadingPosts)

const postId = computed<ComputedRef<Array<InterestType>>>(() => store.getters[POST_STORE.GETTERS.POST_ID])

const goToChat = (item) => {
  router.push(`/${path}/communities/${id}/posts/${postId.value}/chats/${item.chat_link}`)
}

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createElementVNode("div", {
      class: _normalizeClass(['modal-dialog', _unref(route).path === `/${_unref(route).path.split('/')[1]}/communities/${_unref(route).params.id}` ? '' : 'modal-lg'])
    }, [
      _createElementVNode("div", _hoisted_2, [
        _createElementVNode("div", _hoisted_3, [
          _createElementVNode("h3", _hoisted_4, [
            _createTextVNode(_toDisplayString(_unref(translate)('interest')) + " ", 1),
            _hoisted_5,
            _createElementVNode("span", _hoisted_6, _toDisplayString(_unref(loading) ? 0 : _unref(data)?.length), 1)
          ]),
          _hoisted_7
        ]),
        _createElementVNode("div", _hoisted_8, [
          (_unref(loading))
            ? (_openBlock(), _createElementBlock("div", _hoisted_9, _hoisted_11))
            : _createCommentVNode("", true),
          (!_unref(loading))
            ? (_openBlock(), _createElementBlock("div", _hoisted_12, [
                (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_unref(data), (item, index) => {
                  return (_openBlock(), _createElementBlock("div", {
                    key: item,
                    class: _normalizeClass(['py-3 d-flex flex-wrap row align-items-center', index !== _unref(data).length - 1 ? 'border-bottom' : ''])
                  }, [
                    _createElementVNode("div", _hoisted_13, [
                      _createVNode(UserAliasIcon, {
                        userType: item.user_type
                      }, null, 8, ["userType"]),
                      _createElementVNode("span", null, _toDisplayString(item.display_name), 1)
                    ]),
                    _createElementVNode("div", _hoisted_14, [
                      _createElementVNode("div", _hoisted_15, [
                        _createElementVNode("span", _hoisted_16, _toDisplayString(_unref(dayjs)(item.created_at).format('YYYY/MM/DD HH:mm')), 1),
                        (item?.chat_link && item?.is_deleted_in_30_days === 0 && item?.available)
                          ? (_openBlock(), _createElementBlock("div", _hoisted_17, [
                              _createVNode(Button, {
                                title: _unref(translate)('chatWithUs'),
                                type: 'secondary',
                                size: "small",
                                class: "chat-btn",
                                onClick: ($event: any) => (goToChat(item))
                              }, null, 8, ["title", "onClick"])
                            ]))
                          : _createCommentVNode("", true)
                      ])
                    ])
                  ], 2))
                }), 128))
              ]))
            : _createCommentVNode("", true)
        ]),
        _createElementVNode("div", _hoisted_18, [
          _createVNode(Button, {
            title: _unref(translate)('close'),
            "data-bs-dismiss": "modal",
            type: 'secondary'
          }, null, 8, ["title"])
        ])
      ])
    ], 2)
  ]))
}
}

})